
import { Card, CardContent } from "@/components/ui/card";
import { useComponentManagement } from "@/hooks/useComponentManagement";
import { ComponentsTable } from "@/components/components/ComponentsTable";
import { ComponentsFilter } from "@/components/components/ComponentsFilter";
import { ComponentsHeader } from "@/components/components/ComponentsHeader";
import { CreateComponentDialog } from "@/components/components/CreateComponentDialog";
import { EditComponentDialog } from "@/components/components/EditComponentDialog";
import { DeleteComponentDialog } from "@/components/components/DeleteComponentDialog";
import { useEffect } from "react";
import { ensureComponentColumns } from "@/utils/services/databaseMigrationService";
import { fixDatabaseSchema } from "@/utils/services/dbFixService";

export default function Componentes() {
  const {
    components,
    componentTypes,
    loading,
    sortColumn,
    sortDirection,
    typeFilter,
    createDialogOpen,
    editDialogOpen,
    deleteDialogOpen,
    currentComponent,
    isSaving,
    isDeleting,
    setFilter,
    setTypeFilter,
    setCreateDialogOpen,
    handleSort,
    handleEdit,
    handleDelete,
    handleUpdateComponent,
    handleCreateComponent,
    handleConfirmDelete
  } = useComponentManagement();

  // Fix: Add explicit setter functions for dialogs that were missing
  const setEditDialogOpen = (open: boolean) => {
    if (!open) handleEdit(null); // This will close the dialog and clear the current component
  };

  const setDeleteDialogOpen = (open: boolean) => {
    if (!open) handleDelete(null); // This will close the dialog and clear the current component
  };

  // Check database schema when component loads
  useEffect(() => {
    // Try both approaches to fix database schema
    ensureComponentColumns().catch(() => {
      // If the RPC approach fails, try the fallback method
      fixDatabaseSchema();
    });
  }, []);

  return (
    <div className="space-y-6">
      <ComponentsHeader onNewComponent={() => setCreateDialogOpen(true)} />
      
      <div className="bg-card border border-border/40 rounded-lg p-4 shadow-sm">
        <ComponentsFilter 
          onFilterChange={setFilter}
          onTypeFilterChange={setTypeFilter}
          typeFilter={typeFilter}
          componentTypes={componentTypes}
        />
      </div>
      
      <Card className="border border-border/40 shadow-sm">
        <CardContent className="p-0">
          <ComponentsTable
            components={components}
            loading={loading}
            sortColumn={sortColumn}
            sortDirection={sortDirection}
            onSort={handleSort}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        </CardContent>
      </Card>

      <CreateComponentDialog
        open={createDialogOpen}
        onOpenChange={setCreateDialogOpen}
        onSave={handleCreateComponent}
        componentTypes={componentTypes}
        isLoading={isSaving}
      />

      <EditComponentDialog
        open={editDialogOpen}
        onOpenChange={setEditDialogOpen}
        component={currentComponent}
        onSave={handleUpdateComponent}
        componentTypes={componentTypes}
        isLoading={isSaving}
      />

      <DeleteComponentDialog
        open={deleteDialogOpen}
        onOpenChange={setDeleteDialogOpen}
        component={currentComponent}
        onConfirm={handleConfirmDelete}
        isLoading={isDeleting}
      />
    </div>
  );
}
